import {
  CaretDownOutlined,
  CaretRightOutlined,
  CaretUpOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { Card, Col, Skeleton, Statistic, Tag, Tooltip } from "antd";
import React from "react";

export default function HomeDashboardCard({
  isLoading,
  title,
  description,
  value,
  formatter,
  suffix,
  tagValue,
  tagSuffix,
  cardKey,
}) {
  const numericTagValue = Number(tagValue || 0);

  const getColor = () => {
    if (numericTagValue > 0) return "green";
    if (numericTagValue < 0) return "red";
    return "orange";
  };

  const getIcon = () => {
    if (numericTagValue > 0) return <CaretUpOutlined />;
    if (numericTagValue < 0) return <CaretDownOutlined />;
    return <CaretRightOutlined />;
  };

  const formatTagValue = () => {
    const decimals = cardKey === "conversao" ? 1 : 2;
    return numericTagValue.toLocaleString("pt-BR", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  };
  return (
    <>
      <Col xs={24} sm={12} lg={6}>
        <Card
          bordered={true}
          className="home-dashboard-card"
          style={{
            textAlign: "center",
            height: "140px",
          }}>
          {isLoading ? (
            <Skeleton
              active
              paragraph={{ rows: 1, width: "100%" }}
              style={{
                height: "115px",
              }}
            />
          ) : (
            <>
              <Statistic
                title={
                  <div style={{ minHeight: 40, fontSize: 15, fontWeight: 500 }}>
                    {title}
                    <Tooltip title={description}>
                      <InfoCircleOutlined style={{ marginLeft: 10 }} />
                    </Tooltip>
                  </div>
                }
                value={value}
                formatter={formatter}
                suffix={suffix}
                valueStyle={{ whiteSpace: "nowrap" }}
              />
              <Tag color={getColor()} className="home-dashboard-tag">
                {getIcon()} {formatTagValue()}
                {tagSuffix || "%"}
              </Tag>
            </>
          )}
        </Card>
      </Col>
    </>
  );
}
